import { Link } from "react-router";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SpecialtyList } from "@/features/company/specialties/components/specialty-list";

const Specialties = () => {
    return (
        <div className="flex h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <div className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        Specialities
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        What each profession can actually do for you.
                    </h1>

                    <p className="lead mx-auto mb-12 max-w-3xl text-center text-neutral-500">
                        Most people book the wrong appointment because nobody
                        explains the difference. Here's what each kind of
                        clinician treats, what a typical visit involves, and
                        when they're the right person to see.
                    </p>
                </div>
                <SpecialtyList />
                <Card size="lg" className="mt-16">
                    <p className="mb-3 text-4xl font-semibold">
                        Still not sure who to book?
                    </p>
                    <p className="mb-9 text-neutral-500">
                        Describe the treatment in your own words and we'll show
                        you which professions handle it — and who's available
                        near you.
                    </p>
                    <Button variant="success">
                        <Link to="/clinicians/find">Browse clinicians</Link>
                    </Button>
                </Card>
            </div>
        </div>
    );
};

export default Specialties;
